import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { Button } from "@/web/components/ui/button";
import { Input } from "@/web/components/ui/input";
import { Label } from "@/web/components/ui/label";

export default function AccountLogin() {
  return (
    <>
      <Helmet><title>Sign in | Cool Wave</title></Helmet>
      <section className="container max-w-md py-14">
        <h1 className="mb-6 text-3xl font-bold">Sign in</h1>
        <form className="space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" placeholder="you@example.com" className="mt-1.5" />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" className="mt-1.5" />
          </div>
          <Button type="button" className="w-full" disabled>Sign in (coming soon)</Button>
          <Button type="button" variant="outline" className="w-full" disabled>Continue with Google</Button>
        </form>
        <p className="mt-6 text-sm text-body">
          New here? <Link to="/account/register" className="font-medium text-brand hover:underline">Create an account</Link>
        </p>
      </section>
    </>
  );
}
